import { graphql } from 'react-relay';

export const contactPageFragment = graphql`
    fragment ContactPage_page on ContactPage {
      path
      id
      breadcrumbs {
        label
        ...Breadcrumb_data
      }
      title
      form {
        ...ContactForm_contactForm
      }
    }
`;
